import { useQuery } from '@tanstack/react-query';
import getApplicationType from 'Api/application-type/getApplicationType';
import getApplicationTypeResponse from './model/response/getApplicationTypeResponse';

const useGetApplicationType = () => {
  return useQuery({
    queryKey: ['application-type'],
    queryFn: async () => {
      const response = await getApplicationType();

      return getApplicationTypeResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetApplicationType;
